<template>
  <div>
    <AnimatedBackground/>
    <div class="viewport viewport-compact" style="z-index: 1;">
      <div class="flex-grow-1"></div>

      <Survey trigger="signing" @on-survey-completed="showCustomerOverview"/>
      <div class="flex-grow-1"></div>
    </div>
  </div>
</template>
<script>
import AnimatedBackground from '@shared/components/AnimatedBackground'
import Survey from '@shared/components/survey/Survey'

export default {
  name: 'SigningSurveyPage',
  components: { AnimatedBackground, Survey },
  methods: {
    showCustomerOverview() {
      this.$router.replace({ name: 'customer-overview' })
    }
  }
}
</script>
